/** Languages of the interface. Uzbek is the default and the fallback. */
export const LANGUAGES = ["uz", "ru", "en"] as const;
export type Language = (typeof LANGUAGES)[number];
export const DEFAULT_LANGUAGE: Language = "uz";

export const LANGUAGE_NAMES: Record<Language, string> = {
  uz: "O‘zbekcha",
  ru: "Русский",
  en: "English",
};
